import React from "react";

interface IProps {
  text: string;
  query: string;
}

export const InverseBoldMatch: React.FC<IProps> = ({ text, query }) => {
  const normalizedQuery = query.trim();
  if (normalizedQuery.length === 0) {
    return <>{text}</>;
  }

  const segments = splitOnMatches(text, normalizedQuery);
  return (
    <>
      {segments.map((segment, segmentIndex) =>
        segment.isMatch ? (
          <span key={segmentIndex} className="type-fs-paragraph">
            {segment.value}
          </span>
        ) : (
          <React.Fragment key={segmentIndex}>{segment.value}</React.Fragment>
        )
      )}
    </>
  );
};

interface Segment {
  value: string;
  isMatch: boolean;
}

const splitOnMatches = (text: string, query: string): Segment[] => {
  const segments: Segment[] = [];
  const lowerText = text.toLowerCase();
  const lowerQuery = query.toLowerCase();
  let cursor = 0;
  while (cursor < text.length) {
    const matchStart = lowerText.indexOf(lowerQuery, cursor);
    if (matchStart === -1) {
      segments.push({ value: text.slice(cursor), isMatch: false });
      break;
    }
    if (matchStart > cursor) {
      segments.push({
        value: text.slice(cursor, matchStart),
        isMatch: false,
      });
    }
    segments.push({
      value: text.slice(matchStart, matchStart + query.length),
      isMatch: true,
    });
    cursor = matchStart + query.length;
  }
  return segments;
};
